// The import's conversation with the server, in small requests.
import api from '../../../ui/api';
import { stagedOperations, operationChunks, savedRun, restoredRun } from './importRun';

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
/** A dropped connection is tried again; an answer from the server (it has a status) is final. */
export async function steady(send) {
  for (let attempt = 0; ; attempt++) {
    try { return await send(); } catch (e) {
      if (e.status || attempt >= 3) throw e;
      await wait(1500 * (attempt + 1));
    }
  }
}

/** Everything the plan is built from, read page by page under one version. */
export async function loadContext() {
  for (let attempt = 0; attempt < 3; attempt++) {
    const context = await steady(() => api.importContext());
    let settled = true;
    for (const table of ['students', 'families', 'enrollments']) {
      context[table] = [];
      for (let after = 0; after != null;) {
        const page = await steady(() => api.importContextRows(table, after));
        if (page.version !== context.version) settled = false;
        context[table].push(...page.rows);
        after = page.next;
      }
    }
    if (settled) return context;
  }
  throw new Error('بيانات النظام تتغير الآن؛ أعد المحاولة بعد قليل');
}

const digest = async (data) => Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(data)))), (b) => b.toString(16).padStart(2, '0')).join('');

/** Save the reviewed plan on the server. Nothing in the school changes yet. */
export async function saveReview({ plan, input, contextVersion, onProgress }) {
  const operations = stagedOperations(plan, input.rows);
  const id = crypto.randomUUID(), revision = await digest(operations);
  const summary = await steady(() => api.importCreate({ id, revision, filename: input.filename, settings: input.settings, structures: input.structures,
    counts: plan.counts, total: operations.length, contextVersion }));
  let sent = 0;
  for (const chunk of operationChunks(operations)) {
    await steady(() => api.importOperations(id, { revision, ...chunk }));
    sent += chunk.operations.length;
    onProgress?.(sent, operations.length);
  }
  return savedRun(summary, plan, input, operations);
}

export async function loadRun(id) {
  const summary = await steady(() => api.importRun(id)), journal = [];
  for (let after = -1; after != null;) {
    const page = await steady(() => api.importRunOperations(id, after));
    journal.push(...page.rows);
    after = page.next;
  }
  return restoredRun(summary, journal);
}
